import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadFileCreateAtom = createMutationAtomFactory(
  'customerPortal.loadFileCreate',
  (input: {
    fileName: string;
    fileSize: number;
    mimeType: string;
    loadId: string;
  }) => ({
    tradeLoadCustomerFileCreate: {
      __args: {
        input: {
          fileName: input.fileName,
          fileSize: input.fileSize,
          mimeType: input.mimeType,
        },
        loadId: input.loadId,
      },
      file: {
        __scalar: true,
      },
      uploadUrl: true,
    },
  }),
  {
    select: (data) => ({
      file: data.tradeLoadCustomerFileCreate.file,
      uploadUrl: data.tradeLoadCustomerFileCreate.uploadUrl,
    }),
  },
);

export const purchaseOrderFileCreateAtom = createMutationAtomFactory(
  'customerPortal.purchaseOrderFileCreate',
  (input: {
    fileName: string;
    fileSize: number;
    mimeType: string;
    purchaseOrderId: string;
  }) => ({
    tradeSalesOrderCustomerFileCreate: {
      __args: {
        input: {
          fileName: input.fileName,
          fileSize: input.fileSize,
          mimeType: input.mimeType,
        },
        salesOrderId: input.purchaseOrderId,
      },
      file: {
        __scalar: true,
      },
      uploadUrl: true,
    },
  }),
  {
    select: (data) => ({
      file: data.tradeSalesOrderCustomerFileCreate.file,
      uploadUrl: data.tradeSalesOrderCustomerFileCreate.uploadUrl,
    }),
  },
);
